import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Receipt } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errText } from "@/lib/api";

let cachedStatus = null;

/** True once the billing app URL is configured, so the button can stay hidden otherwise. */
export const useBillingReady = () => {
  const [ready, setReady] = useState(cachedStatus?.base_url ? true : cachedStatus === null ? null : false);

  useEffect(() => {
    if (cachedStatus !== null) return;
    let alive = true;
    api
      .get("/billing/status")
      .then(({ data }) => {
        cachedStatus = data;
        if (alive) setReady(Boolean(data.base_url));
      })
      .catch(() => {
        cachedStatus = {};
        if (alive) setReady(false);
      });
    return () => {
      alive = false;
    };
  }, []);

  return ready;
};

export const FeeNoteButton = ({
  matterId,
  eventId,
  variant = "outline",
  className = "rounded-full h-10 px-4",
  label = "New fee note",
  testId = "fee-note-btn",
}) => {
  const ready = useBillingReady();
  const [busy, setBusy] = useState(false);
  if (!ready) return null;

  const open = async () => {
    setBusy(true);
    try {
      const { data } = await api.get("/billing/fee-note-link", {
        params: { matter_id: matterId, event_id: eventId },
      });
      window.open(data.url, "_blank", "noopener");
    } catch (e) {
      toast.error(errText(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      variant={variant}
      data-testid={testId}
      onClick={open}
      disabled={busy}
      className={className}
    >
      <Receipt className="h-4 w-4 mr-2" />
      {busy ? "Opening…" : label}
    </Button>
  );
};
